import * as hooks from './hooks';
import * as pixelHooks from './hooks/usePixel';
import * as viewabilityHooks from './hooks/useViewAbility';
import { useBrandSafetyProps, handleBoolBsSupportCountry } from './hooks/useBrandSafetyProps';
import { useBrandSafetySupport } from './hooks/useBrandSafetySupport';
import { useTrackUrl, useTrackUrlShow } from './hooks/useTrackUrl';
import { useWebsiteEvents } from './hooks/useWebsiteEvents';
import { useAppEvents } from './hooks/useAppEvents';
import { useAppList } from './hooks/useAppList';
import { usePixelList } from './hooks/usePixelList';
import { useCreativeOfflineEvents } from './hooks/useCreativeOfflineEvents';
import { useOfflineEventsDefaultData } from './hooks/useOfflineEventsDefaultData';

import TtamTrackingPixelEcho from './pixel-echo/index.vue';
import TtamTrackingPixelSelect from './pixel-select/index.vue';
import TtamTrackingPixelTips from './pixel-tips/index.vue';

import TtamTrackingUrlSetting from './url-setting/index.vue';

import TtamTrackingViewability from './viewability/index.vue';
import TtamTrackingViewabilitySwitch from './viewability/switch.vue';

import TtamTrackingBrandSafety from './brand-safety/index.vue';
import TtamTrackingBrandSafetyTips from './brand-safety-tips/index.vue';

import TtamTrackingRetargetingTip from './track-tip/index.vue';

import TtamAdTrackingWebsiteEventsCompose from './tracking-website-events-compose.vue';
import TtamAdTrackingAppEventsCompose from './tracking-app-events-compose.vue';
import TtamCreativeTrackOfflineEvents from './track-offline-events/index.vue';

export default {
  ...hooks,
  ...pixelHooks,
  ...viewabilityHooks,
  useBrandSafetyProps,
  useBrandSafetySupport,
  useTrackUrl,
  useTrackUrlShow,
  useAppEvents,
  useWebsiteEvents,
  handleBoolBsSupportCountry,
  useCreativeOfflineEvents,
  useOfflineEventsDefaultData,
  useAppList,
  usePixelList,

  TtamTrackingPixelEcho,
  TtamTrackingPixelSelect,
  TtamTrackingPixelTips,

  TtamTrackingUrlSetting,

  TtamTrackingViewability,
  TtamTrackingViewabilitySwitch,

  TtamTrackingBrandSafety,
  TtamTrackingBrandSafetyTips,

  TtamTrackingRetargetingTip,

  TtamAdTrackingWebsiteEventsCompose,
  TtamAdTrackingAppEventsCompose,
  TtamCreativeTrackOfflineEvents,
};
